// extracted by mini-css-extract-plugin
module.exports = {"header":"_4zCYs__header","main":"_2p4tg__main","downloadWrapper":"_2VBmU__downloadWrapper","downloadIcon":"_2Dvb1__downloadIcon","downloadLink":"_2rQm1__downloadLink"};